import { NgModule } from "@angular/core";
import { RolesPrivilegesComponent } from "./roles-privileges.component";
import { MenuModule } from "../../menu/menu.module";

@NgModule({
  imports: [MenuModule, RolesPrivilegesComponent],
  declarations: [],
})
export class RolesPrivilegesModule { }
